







































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Message} from "@/model/message";
import MessageSelectStatus from "@/components/MessageSelectStatus.vue";
import BrandIcon from "@/components/BrandIcon.vue";
@Component({
  components: {BrandIcon, MessageSelectStatus}
})
export default class MessageWithHistory extends Vue {
  @Prop()
  message!: Message

  @Prop()
  messageHistory!: Message[]

  showOldCases = false
}
